import { SET_DARK_MODE } from '../actionConstants';

export const setDarkModeAction = (payload) => {
  return {
    type: SET_DARK_MODE,
    payload,
  };
};
